import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
 
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { AlertService } from './alert.service';
import { ApiService } from './api.service';
 
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
 
  constructor(public alerter : AlertService, public api:ApiService) {}
 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      // console.log("Interecepted response: " + JSON.stringify(err));
    return next.handle(request).do(
      (event: HttpEvent<any>) => {}, 
      // data => {
      //   console.log('data');
      // },
      err => {
      if (err instanceof HttpErrorResponse) {
        this.api.isLoading = false;
        console.log("error response", err);
        if(ApiService.isLoggingOut)
          return;
        this.alerter.alertError(err, "Server request failed");
      }
    });
  }
}